import { render, staticRenderFns } from "./pronew.vue?vue&type=template&id=4b27d042&scoped=true"
import script from "./pronew.vue?vue&type=script&lang=js"
export * from "./pronew.vue?vue&type=script&lang=js"
import style0 from "./pronew.vue?vue&type=style&index=0&id=4b27d042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b27d042",
  null
  
)

export default component.exports